import client from '../httpClient';

const autoRegistResponseControlSearchApi = (params) => {
  return client.get('/responses/automation-controls/', JSON.stringify(params));
};

export default autoRegistResponseControlSearchApi;
